import axios from "axios";
import { authInterceptor, unauthorizedInterceptor } from "./auth-interceptor";
import errorHandler from "./error-handler";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

// Register auth interceptor
authInterceptor(client);

// Register unauthorized interceptor
unauthorizedInterceptor(client);

// Register error interceptor
client.interceptors.response.use(undefined, (error) => errorHandler(error));

export default client;
